import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, NgZone, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AddEmailComponent } from 'src/app/dialog/add-email/add-email.component';
import { DownloadAppDialogComponent } from 'src/app/dialog/download-app-dialog/download-app-dialog.component';
import { TermsDialogComponent } from 'src/app/dialog/terms-dialog/terms-dialog.component';
import { FACEBOOK_STATUS } from 'src/app/enums/facebook-status.enum';
import { STATUS } from 'src/app/enums/status.enum';
import { User } from 'src/app/models/user';
import { DataService } from 'src/app/services/data.service';
import { LoadingService } from 'src/app/services/loading.service';
import { SocialLoginProvider, UserService } from 'src/app/services/user.service';
import { UtilityService } from 'src/app/services/utility.service';
import { fade, fadeOp } from 'src/app/util/animations.util';
import { environment } from 'src/environments/environment';
// import { SocialAuthService } from "angularx-social-login";
// import { FacebookLoginProvider, GoogleLoginProvider } from "angularx-social-login";
declare var gapi: any;
declare const FB: any;
declare const AppleID: any;

var gAuth2: any;

const $ = window as any;

interface DialogData {
  title: string;
  msg: string;
}

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css'],
  animations: [
    fadeOp,
    fade
  ]
})
export class SignInComponent implements OnInit, OnDestroy {

  user!: User;
  version = ""
  isWrong = false;
  loginForm!: FormGroup;
  submitted: boolean = false;
  ios: string = '';
  android: string = '';
  auth2: any;
  googleLoad: boolean = false;
  facebookLoad: boolean = false;

  private redirectURL!: string;
  isSmallScreen: boolean = false;
  channel: string = 'web';


  constructor(
    private userService: UserService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private utility: UtilityService,
    private ngZone: NgZone,
    private http: HttpClient,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.ios = environment.IOS_APP;
    this.android = environment.IOS_APP;
    this.loginForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required]
    });
    this.version = this.dataService.getVersion()
    this.user = new User;
    this.loadGoogleSDK();
    this.loadFacebookSDK();
    this.loadAppleSDK();
    this.redirectURL = this.route.snapshot.queryParams.returnUrl;
    this.checkScreenSize();
    setTimeout(() => {
      this.popUp();
    }, 1000);
  }

  private generateNonce(length = 32) {
    const array = new Uint8Array(length);
    window.crypto.getRandomValues(array);
    return Array.from(array, byte => ('0' + byte.toString(16)).slice(-2)).join('');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 700;
  }


  popUp() {
    const isHasSeenDownloadDialog = sessionStorage.getItem("hasSeenDownloadDialog") ? true : false;

    if (this.isSmallScreen && !isHasSeenDownloadDialog) {
      this.dialog.open(DownloadAppDialogComponent, {
        width: '450px',
        panelClass: 'download-app-container',
        autoFocus: false,
        disableClose: true,
        data: {
          isMobile: this.isSmallScreen
        }
      }).afterClosed();
    }

  }
  onSigninWithGoogle(googleUser: any): void {
    const user = googleUser.getAuthResponse();

    // const user = JSON.parse(JSON.stringify(googleUser))
    // var token;
    // for (let key in user) {
    //   if (user[key].access_token)
    //     token = user[key].access_token;
    // }
    this.userService.socialLogin(user.id_token, SocialLoginProvider.GOOGLE, this.channel, environment.APPLE_REDIRECT_URI)
      .then((response) => {
        this.ngZone.run(() => {
          if (response.status != STATUS.SUCCESS) {
            return;
          }
          if (!response.data.user.is_agree_term_condition) {
            this.onOpenTermAndConditionDialog(response.data);
            return;
          }
          this.userService.onSuccessLogin(response.data);
          this.redirect();
        })
        // this.ngZone.run(() => this.router.navigateByUrl(this.redirectURL));
      })
      .catch(console.error)
  }

  private onOpenTermAndConditionDialog(response: any): void {
    this.dialog.open(TermsDialogComponent, {
      width: "1000px",
      data: {
        type: 'registration',
        token: response.token
      }
    }).afterClosed()
      .subscribe(
        token => {
          if (!token) {
            return;
          }
          this.userService.onSuccessLogin(response);
          this.onAgree(token);
        }
      )
  }

  private onAgree(token: string): void {
    const url = environment.API_URL + 'agree/term-condition';
    const headers = new HttpHeaders({ Authorization: "Bearer " + token });
    this.loadingService._setLoading();
    this.http.put<any>(url, {}, {
      headers
    })
      .subscribe({
        next: (response) => {
          if (response.status != STATUS.SUCCESS) {
            return;
          }
          // this.userService.onSuccessLogin(response);
          this.redirect();
        },
        error: error => {
          throw new Error(error)
        },
        complete: () => {
          this.loadingService._clearLoading();
        }
      });
  }

  private redirect(): void {
    this.router.navigateByUrl(this.redirectURL);
  }

  onSigninWithFacebook(): void {
    const scope = { scope: 'public_profile,email' };
    FB.login((fb_response: any) => {
      if (fb_response.status == FACEBOOK_STATUS.CONNECTED) {
        this.userService.socialLogin(fb_response.authResponse.accessToken, SocialLoginProvider.FACEBOOK, this.channel, environment.APPLE_REDIRECT_URI)
          .then((response) => {
            this.ngZone.run(() => {
              if (!response.data.user.is_agree_term_condition) {
                this.onOpenTermAndConditionDialog(response.data);
                return;
              }
              this.userService.onSuccessLogin(response.data);
              this.redirect();
            });
          })
          .catch((response) => {
            this.ngZone.run(() => {
              const errors = response.errors;
              if (Array.isArray(errors)) {
                const tokenError = errors.find((error) => error.param === 'token');
                if (tokenError) {
                  this.openLoginFailedDialog();
                }
              }
            });
          })
      }
    }, scope);
  }
  toggleInput(input: HTMLInputElement): void {
    input.type = input.type == 'password' ? 'text' : 'password';
  }

  onSubmit(): void {
    const user = this.loginForm.value;

    if (this.loginForm.invalid) {
      return this.loginForm.markAllAsTouched();
    }

    this.submitted = true;
    this.userService.login(user.email, user.password)
      .then(() => {
        this.router.navigateByUrl(this.redirectURL);
      })
      .catch((response: any) => {
        this.submitted = false;

        if (response.errors && Array.isArray(response.errors)) {
          const emailError = response.errors.find((error: any) => error.param === 'email');
          if (emailError && emailError.msg === 'Invalid value') {
            this.setError({ email: true }, this.emailControl);
          }
        }

        // Handle message-based errors
        if (response.message) {
          switch (response.message) {
            case "Invalid username or password":
              this.setError({ incorrect: true }, this.loginForm);
              break;
            case "Method not found":
            case "Error invoking post: Method not found":
              this.setError({ serverUnavailable: true }, this.loginForm);
              break;
            default:
              this.setError({ error: true }, this.loginForm);
          }
        } else {
          // Fallback if response is unknown
          this.setError({ error: true }, this.loginForm);
        }
      });
  }

  loadFacebookSDK(): void {
    // If SDK already loaded, do nothing
    if ((window as any).FB) {
      return;
    }

    (window as any).fbAsyncInit = () => {
      FB.init({
        appId: environment.FACEBOOK_CLIENT_ID,
        cookie: true,
        xfbml: true,
        version: 'v24.0'
      });

      this.facebookLoad = true;

      FB.AppEvents?.logPageView();
    };

    const scriptId = 'facebook-jssdk';

    if (!document.getElementById(scriptId)) {

      const js = document.createElement('script');
      js.id = scriptId;
      // new SDK script
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      js.async = true;

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(js, firstScript);
    }
  }

  loadGoogleSDK(): void {
    $.googleAsyncInit = () => {
      gapi.load('auth2', () => {
        const auth2 = gapi.auth2.init({
          client_id: environment.GOOGLE_CLIENT_ID,
          cookiepolicy: 'single_host_origin'
        });
        gAuth2 = auth2;
        auth2.attachClickHandler(document.getElementById('google-signin'), {},
          this.onSigninWithGoogle.bind(this),
          function (error: any) {
            console.error(JSON.stringify(error));
          }
        );
      });
    }
    const js = document.createElement('script');
    js.id = "googleSDK";
    js.src = "https://apis.google.com/js/platform.js?onload=googleAsyncInit";
    document.body.appendChild(js);
  }

  onSigninWithApple(): void {
    if (typeof AppleID === 'undefined') {
      console.error('AppleID not available');
      return;
    }

    AppleID.auth.signIn().then(
      (response: any) => {
        if (response) {
          this.userService.socialLogin(response.authorization.code, SocialLoginProvider.APPLE, this.channel, environment.APPLE_REDIRECT_URI)
            .then((response) => {
              this.ngZone.run(() => {
                if (!response.data.user.is_agree_term_condition) {
                  this.onOpenTermAndConditionDialog(response.data);
                  return;
                }
                this.userService.onSuccessLogin(response.data);
                this.redirect();
              });
            })
            .catch((response) => {
              this.ngZone.run(() => response.error);
            })
        }
      },
      (error: any) => {
        console.error('Apple sign-in failed', error);
      }
    );
  }

  loadAppleSDK(): void {
    if (document.getElementById('appleSDK')) {
      this.initApple();
      return;
    }

    const script = document.createElement('script');
    script.id = 'appleSDK';
    script.src =
      'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
    script.async = true;

    script.onload = () => {
      this.initApple();
    };

    document.body.appendChild(script);
  }

  private initApple(): void {
    if (typeof AppleID === 'undefined') {
      console.error('AppleID not available');
      return;
    }

    const opt = {
      clientId: environment.APPLE_SERVICE_ID,
      redirectURI: environment.APPLE_REDIRECT_URI,
      scope: 'email name',
      usePopup: true,
      nonce: this.generateNonce(),
      state: 'web'
    }
    AppleID.auth.init(opt);
  }


  destroyGoogle(): void {
    document.getElementById('googleSDK')?.remove();
  }

  private setError(error: { [key: string]: boolean }, control: AbstractControl) {
    control.setErrors(error)
  }

  openLoginFailedDialog(): void {
    const dialogConfig = {
      width: '550px',
      disableClose: true,
      autoFocus: false,
      data: <DialogData>{
        title: 'TITLE.LOGIN_FAILED',
        msg: 'MSG.LOGIN_FAILED_MSG'
      }
    };

    this.dialog.open(AddEmailComponent, dialogConfig)
      .afterClosed()
      .subscribe(result => {
        if (result) {
          console.log('Dialog closed with result:', result);
        } else {
          console.log('Dialog was dismissed');
        }
      });
  }

  openDialog() {
    const dialogRef = this.dialog.open(AddEmailComponent);

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  changeLang(lang: string): void {
    this.utility.changeLang(lang)
  }
  get availableLang(): string[] {
    return this.utility.getAvailableLang()
  }
  get currentLang(): string {
    return this.utility.getLang();
  }

  get emailControl(): AbstractControl {
    return this.loginForm.get('email')!;
  }

  get passwordControl(): AbstractControl {
    return this.loginForm.get('password')!;
  }
  ngOnDestroy(): void {
    this.destroyGoogle();
  }
}
